module.exports = __webpack_public_path__ + "assets/目标管理.e064d5c3.svg";